import { Injectable } from '@angular/core';
import { pickerUrl, tenantSlugFromPath, workspaceUrl } from '../utils/tenant-path.util';

/**
 * Path-based tenancy: a workspace lives under  /w/<slug>/...
 *
 * The router base href is set to /w/<slug>/ at bootstrap (app.config.ts), so the
 * Angular router sees ordinary routes ("/dashboard", "/projects/x") while the
 * address bar shows /w/<slug>/dashboard. Every API call carries the slug in an
 * X-Tenant-Key header (tenant.interceptor.ts).
 */
@Injectable({ providedIn: 'root' })
export class TenantService {
  /** <slug> from /w/<slug>/... on the current page, or null (marketing / login / admin). */
  readonly currentSlug: string | null = tenantSlugFromPath();

  get inWorkspace(): boolean {
    return this.currentSlug !== null;
  }

  /** Absolute in-app URL for a workspace (path-based). */
  urlFor(slug: string, innerPath = '/dashboard'): string {
    return workspaceUrl(slug, innerPath);
  }

  /** Hard-navigate into a workspace (login / workspace switch). */
  enter(slug: string, innerPath = '/dashboard'): void {
    if (typeof window !== 'undefined') {
      window.location.href = workspaceUrl(slug, innerPath);
    }
  }

  /** Hard-navigate to the bare-domain workspace picker (drops the /w/<slug> context). */
  goToPicker(): void {
    if (typeof window !== 'undefined') {
      window.location.href = pickerUrl('/workspaces');
    }
  }
}
